import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
    MSAL_GUARD_CONFIG,
    MsalGuardConfiguration,
    MsalService,
} from '@azure/msal-angular';
import { AuthConstants } from 'src/core/utilitites/auth.constants';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-legacy',
    templateUrl: './legacy.component.html',
    styleUrls: ['./legacy.component.scss'],
    standalone: false
})
export class LegacyComponent implements OnInit {
    locale: string = 'en-US';
    constructor(
        private msalService: MsalService,
        @Inject(MSAL_GUARD_CONFIG)
        private msalGuardConfig: MsalGuardConfiguration,
        private activatedRoute: ActivatedRoute,
        private localization: LocalizationService
    ) {}
    
    ngOnInit(): void {
        this.locale = this.activatedRoute.snapshot.queryParams?.locale;
        
        const authConfig = JSON.parse(
          JSON.stringify(AuthConstants.authConfig)
        );
        const redirectUri = !environment.production
            ? window.location.origin + '/impersonate'
            : window.location.origin + '/merlin-cloud/impersonate';
        authConfig['redirectUri'] = redirectUri ;
        const redirectConfig: any = {
            ...this.msalGuardConfig.authRequest,
        };
        this.msalService.loginRedirect({
            scopes: redirectConfig.scopes,
            authority: environment.forgotPasswordDeepLinkAuthority,
            redirectStartPage: redirectUri,
            extraQueryParameters: {
                option: 'forgotpassword',
                ui_locales: this.locale ? this.locale : 'en-US',
            },
        });
    }
    generateScopes() {
      const returnArray = [];
      environment.scopePermissions.split(' ').forEach((scopeUrl) => {
          returnArray.push(environment.scope + '/' + scopeUrl);
      });
      return returnArray;
  }
  translate(key) {
    return this.localization.generateLocalizedStr(key);
  }
  
}
